angular
    .module("skillBuilderSaaS")
    .factory("statusCodeService", ["$rootScope", function ($rootScope) {
        return {
            setStatusCode: function (code) {
                $rootScope.statusCode = code;
            }
        };
    }]);
